import {container, title, defaultFont} from "assets/jss/material-kit-react.jsx";

const landingPageStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    textAlign: "center",
    flexDirection:"column",
    justifyContent:"flex-end",
    alignItems:"center",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    textAlign: "center",
    marginTop: 20,
    // marginBottom: 15,
    marginBottom: 65,
    fontSize: 65,
    // lineHeight: 65,
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none"
  },
  xsTitle: {
    ...title,
    display: "inline-block",
    position: "relative",
    textAlign: "center",
    // marginTop: 20,
    // marginBottom: 15,
    marginBottom: 35,
    fontSize: 45,
    // lineHeight: 65,
    minHeight: "28px",
    color: "#FFFFFF",
    textDecoration: "none"
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexCenterColumn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  fixedPreviewContainer: {
    backgroundColor: 'rgba(41, 41, 41, 0.9)',
    marginTop: 124,
    height: 100,
    width: 500,
    borderRadius: 10,
    position: 'fixed',
    zIndex: 1000,
  },
  voteButton: {
    ...defaultFont,
    marginTop: 40,
    padding: 15,
    // paddingBottom: 15,
    border: "7px solid #000",
    backgroundColor: "#fff",
    boxShadow: "0 0 0 8px #fff",
    // font-family: Montserrat, sans-serif;
    color: "#000",
    fontSize: 30,
    fontWeight: 700,
    "&:hover,&:focus": {
      color: "#FFFFFF",
      background: "rgba(200, 200, 200, 0.2)"
    },
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0"
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  }
};

export default landingPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/landingPage.jsx